module.exports = __webpack_public_path__ + "img/00village02.e903225b.jpg";